module.exports = __webpack_public_path__ + "f506abffe1bb6f20b68636d7f41353f8.MP3";